/* Pressd — Cart Drawer + Add to Cart */

class PressdCart {
  constructor() {
    this.drawer   = document.querySelector('.pressd-cart-drawer');
    this.overlay  = document.querySelector('.pressd-cart-overlay');
    this.itemsEl  = document.querySelector('.pressd-cart-items');
    this.totalEl  = document.querySelector('.pressd-cart-total-amount');
    this.countEls = document.querySelectorAll('.pressd-cart-count');

    if (!this.drawer) {
      console.warn('Pressd: cart drawer not found');
      return;
    }

    this._bindEvents();
    this.refresh();
  }

  _bindEvents() {
    // Open cart
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-cart]')) {
        e.preventDefault();
        this.open();
      }
    });

    // Close cart
    document.addEventListener('click', (e) => {
      if (e.target.closest('.pressd-cart-close')) this.close();
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Add to cart — collection card buttons
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.pressd-card-atc');
      if (!btn || btn.disabled) return;
      const variantId = btn.dataset.variantId;
      if (variantId) this.addItem(parseInt(variantId, 10), 1, btn);
    });

    // Add to cart — product page form
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('#pressd-product-form');
      if (!form) return;
      e.preventDefault();
      const variantInput = form.querySelector('[name="id"]');
      const atcBtn = form.querySelector('#pressd-atc-btn');
      if (!variantInput) return;
      const variantId = parseInt(variantInput.value, 10);
      this.addItem(variantId, 1, atcBtn);
    });
  }

  open() {
    if (!this.drawer) return;
    this.drawer.classList.add('open');
    if (this.overlay) this.overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.refresh();
  }

  close() {
    if (!this.drawer) return;
    this.drawer.classList.remove('open');
    if (this.overlay) this.overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  async addItem(variantId, quantity = 1, btn = null) {
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>`;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });

      if (!res.ok) {
        const err = await res.json();
        console.error('Add to cart error:', err);
        return;
      }

      await this.refresh();
      this.open();

    } catch (err) {
      console.error('Cart error:', err);
    } finally {
      if (btn) {
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = btn.id === 'pressd-atc-btn'
            ? 'Add to Bag'
            : `<svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"/></svg>`;
        }, 2000);
      }
    }
  }

  async refresh() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();

      // Update count badges
      this.countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Update total
      if (this.totalEl) {
        this.totalEl.textContent = this._formatMoney(cart.total_price);
      }

      // Update items
      if (this.itemsEl) {
        if (cart.items.length === 0) {
          this.itemsEl.innerHTML = `
            <div style="text-align:center;padding:40px 24px;color:var(--grey-mid);">
              <div style="font-size:40px;margin-bottom:12px;">💅</div>
              <p style="font-size:1rem;font-weight:600;margin-bottom:6px;">Your bag is empty</p>
              <p style="font-size:0.85rem;">Time to find your next fave set</p>
            </div>`;
        } else {
          this.itemsEl.innerHTML = cart.items.map(item => this._renderItem(item)).join('');
          this.itemsEl.querySelectorAll('[data-remove-item]').forEach(btn => {
            btn.addEventListener('click', () => this.removeItem(btn.dataset.removeItem));
          });
        }
      }
    } catch(err) {
      console.error('Cart refresh error:', err);
    }
  }

  async removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    await this.refresh();
  }

  _renderItem(item) {
    const price = this._formatMoney(item.final_line_price);
    const img   = item.image || '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:0.78rem;color:var(--grey-mid);margin:2px 0 6px;">${item.variant_title}</p>` : '';
    return `
      <div style="display:flex;gap:14px;margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid var(--pink-soft);">
        ${img ? `<img src="${img}" alt="${item.title}" style="width:72px;height:72px;object-fit:cover;border-radius:10px;flex-shrink:0;">` : ''}
        <div style="flex:1;min-width:0;">
          <p style="font-size:0.88rem;font-weight:600;margin-bottom:2px;line-height:1.3;">${item.product_title}</p>
          ${variant}
          <p style="font-weight:700;color:var(--pink-hot);font-size:0.95rem;">${price}</p>
          <div style="display:flex;align-items:center;gap:12px;margin-top:8px;">
            <span style="font-size:0.82rem;color:var(--grey-mid);">Qty: ${item.quantity}</span>
            <button data-remove-item="${item.key}" style="background:none;border:none;cursor:pointer;color:var(--grey-mid);font-size:0.78rem;text-decoration:underline;padding:0;">Remove</button>
          </div>
        </div>
      </div>`;
  }

  _formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
}

// Init after DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { window.pressdCart = new PressdCart(); initDropdowns(); });
} else {
  window.pressdCart = new PressdCart();
  initDropdowns();
}

// Nav dropdowns with hover delay
function initDropdowns() {
  document.querySelectorAll('.pressd-nav-dropdown').forEach(dropdown => {
    let timer;
    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      dropdown.classList.add('open');
    });
    dropdown.addEventListener('mouseleave', () => {
      timer = setTimeout(() => dropdown.classList.remove('open'), 200);
    });
  });
}
